import mixpanel from 'mixpanel-browser';

const MIXPANEL_TOKEN = import.meta.env.VITE_MIXPANEL_TOKEN;

let initialized = false;

export function initMixpanel() {
  if (!MIXPANEL_TOKEN) {
    console.warn('Mixpanel token not found. Analytics disabled.');
    return;
  }

  if (!initialized) {
    mixpanel.init(MIXPANEL_TOKEN, {
      debug: import.meta.env.DEV,
      track_pageview: true,
      persistence: 'localStorage',
    });
    initialized = true;
  }
}

export function identifyUser(userId: string, traits?: Record<string, any>) {
  if (!initialized) return;
  
  mixpanel.identify(userId);
  
  if (traits) {
    mixpanel.people.set(traits);
  }
}

export function trackEvent(eventName: string, properties?: Record<string, any>) {
  if (!initialized) return;
  
  mixpanel.track(eventName, properties);
}

export function setUserProperties(properties: Record<string, any>) {
  if (!initialized) return;
  
  mixpanel.people.set(properties);
}

export function incrementUserProperty(property: string, amount: number = 1) {
  if (!initialized) return;
  
  mixpanel.people.increment(property, amount);
}

export function resetUser() {
  if (!initialized) return;
  
  mixpanel.reset();
}
